import React, { useEffect } from 'react'
import axios from 'axios'
import { MetricTimeUnit, MeasureType, Category } from 'enums'
import { createMetric, createInsightCount } from 'utils/runSearchUtil'
import { useAppDispatch } from 'app/hooks'
import { getInsightContentData } from 'features/insightContent/asyncThunks'
import { getMetricSeries } from 'utils/measureTypeUtil'
import InsightContentType from 'components/insightContent/enum/InsightContentType'
import useRefreshTimestamp from 'hooks/useRefreshTimestamp'
import { SocialWebTimelineWidget as SocialWebTimelineWidgetType } from 'schemas/SocialWebTimelineWidgetSchema'
import { toFilter } from 'utils/widgetUtil'
import { ERROR_MESSAGE } from 'features/insightContent/insightContentSlice'
import { QUERY_EXACT_TERMS } from './constants'

const createSearches = (widgetSetting: SocialWebTimelineWidgetType, isAudienceQuery?: boolean) => {
  const { precision, selectedTopic } = widgetSetting
  const filter = toFilter(widgetSetting)

  const searches = []
  const metricValueSearch = createMetric(
    -1,
    '',
    precision!,
    [selectedTopic.topicId!],
    filter,
    getMetricSeries(MeasureType.POSTS),
    [MetricTimeUnit.ALL],
    { isAudienceQuery }
  )
  searches.push(metricValueSearch)

  const insightCountSearch = createInsightCount(
    -1,
    '',
    precision!,
    [selectedTopic.topicId!],
    filter,
    MeasureType.POSTS,
    [Category.PHRASES],
    { exactCount: QUERY_EXACT_TERMS }
  )
  searches.push(insightCountSearch)

  return searches
}

const PrerequisiteRunSearchEffect = ({
  widgetSetting,
  children,
  isAudienceQuery
}: {
  widgetSetting: SocialWebTimelineWidgetType
  children: React.ReactNode
  isAudienceQuery?: boolean
}) => {
  const dispatch = useAppDispatch()
  const refreshTimestamp = useRefreshTimestamp()

  useEffect(() => {
    // eslint-disable-next-line prefer-destructuring
    const CancelToken = axios.CancelToken
    const source = CancelToken.source()

    const searches = createSearches(widgetSetting, isAudienceQuery)
    dispatch(
      getInsightContentData({
        insightContentType: InsightContentType.FLUCTUATION_POPULAR_TERMS_PREREQUISITE,
        searches,
        timestamp: refreshTimestamp,
        requestConfig: {
          cancelToken: source.token
        }
      })
    )

    return () => {
      source.cancel(ERROR_MESSAGE.REQUEST_CANCELLED)
    }
  }, [dispatch, widgetSetting, refreshTimestamp, isAudienceQuery])

  return <>{children}</>
}

export default PrerequisiteRunSearchEffect
